export const unleashProxyConfig = {
  url: 'https://egerdau-unleashp-dev.gerdau.digital/proxy',
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY as string,
  refreshInterval: 60,
  appName: 'egerdau-web'
};
